const normalizedNetwork = process.env.REACT_APP_NETWORK?.trim().toUpperCase();

export const API_URL = normalizedNetwork === "MAINNET"
    ? "https://prod-api.tasks.market/"
    : "https://stg-api-tasks.quecko.org/"; 